export const SEARCH_MENU_ID = 'product-search-dialog';
export const ADVANCED_SEARCH_URL = '/secure/QuickSearch.jspa?searchString=';
